import Form from '@utilities/form';
import addAlertMessage from '@utilities/errors/add-alert-message';
import ScrollTo from "@utilities/scroll-to";
import Events from '@utilities/events';
import contactConstraints from './contact-form-email-constraints';

const JS_HOOK_CONTACT_ALERT = '[js-hook-contact-email-alert]';
const JS_HOOK_VALIDATORS = '[js-hook-contact-form-email-validators]';
const JS_HOOK_FORM_FIELDS = '[js-hook-contact-form-email-fields]';
const JS_HOOK_RESPONSE_WRAPPER = '[js-hook-contact-form-response]';
const JS_HOOK_FORM_PAGE = '[js-hook-contact-form-page]';

const HIDDEN_CLASS = 'u-hidden';

/**
 * Used to handle Contact requests from user
 *
 * @class ContactForm
 * @extends {Form}
 */
class ContactFormEmail extends Form {
  constructor(element) {
    super(element);
    this.messageSelector = JS_HOOK_CONTACT_ALERT;
    this.formFields = this.form.querySelector(JS_HOOK_FORM_FIELDS);
    this.formPage = document.querySelector(JS_HOOK_FORM_PAGE);
    this.successText = this.form.dataset.simpleSuccessMessage;
    this.errorText = this.form.dataset.simpleErrorMessage;
    this.locale = this.form.dataset.locale || '';

    // Init constraints
    this.initConstraints();

    // Events: Submit & Change Events
    this.bindChangeEvents();
    this.bindSubmitEvents();
  }

  /**
   * Init constraints for form validation for validate.js
   */
  initConstraints() {
    this.constraints = contactConstraints(this.locale);
  }

  getDefaultValidators() {
    const { validators } = this.element.querySelector(JS_HOOK_VALIDATORS).dataset;
    const parsedValidators = Form.parseDefaults(validators);
    return parsedValidators.data;
  }

  processServerErrors() {
    addAlertMessage({ message: this.errorText, hook: this.messageSelector, type: 'error' });
    this.form.reset();
  }

  afterSubmitFormSuccess(data) {
    const variationAttribute = this.form.querySelector('#dwfrm_contact_emailSubject');
    const request = variationAttribute && variationAttribute.nodeName === 'SELECT' ? variationAttribute.options[variationAttribute.selectedIndex].textContent.replace(/\n/g, '').trim() : null;
    const obj = {
      data: {
        event: 'contact_us',
        request
      }
    };
    if (data && data.userData) {
      obj.data.user_data = data.userData;
    }
    Events.$trigger('gtm::push', obj);

    addAlertMessage({ message: this.successText, hook: this.messageSelector, type: 'success' });
    this.formFields.classList.add(HIDDEN_CLASS);
    this.form.reset();

    ScrollTo.scrollTo(this.form, 350, 180);

    // DHCorp fakes a new page load after successful form submission
    const responseWrapper = document.querySelector(JS_HOOK_RESPONSE_WRAPPER);
    if (data && responseWrapper && this.formPage) {
      responseWrapper.innerHTML = data;
      this.formPage.classList.add(HIDDEN_CLASS);
    }
  }

  simpleAfterSubmitFormError() {
    addAlertMessage({ message: this.errorText, hook: this.messageSelector, type: 'error' });
  }
}

export default ContactFormEmail;
